import { Stack, Typography } from '@mui/material'

import { PriceActiveLine, PriceProductCart } from '@/components/ProductPrice/ProductPrice.styled'
import { SmallestUnitPrice } from '@/components/ProductPrice/SmallestUnitPrice'
import { PriceLabelEnum } from '@/enums/PriceLabelEnum'
import { getPriceMarkers } from '@/helpers/getPriceMarkers'
import { useTenant } from '@/hooks/useTenant'
import { useTranslations } from '@/hooks/useTranslations'
import { commerceTheme as theme } from '@/themes/commerce/theme'

import type React from 'react'
import type { getBffPrices } from '@/helpers/getBffPrices'

interface Props {
  price?: ReturnType<typeof getBffPrices>
  isLoading?: boolean
}
export const CardPrice: React.FC<Props> = ({ price, isLoading = false }) => {
  const { translate } = useTranslations()
  const tenant = useTenant()

  const { fullPrice, totalPrice } = getPriceMarkers(price ?? null, tenant.currency, tenant.locale)

  return (
    <Stack sx={{ width: '100%', textAlign: 'right' }}>
      <>
        {isLoading ? (
          <PriceProductCart />
        ) : (
          <>
            {fullPrice && (
              <Typography component="p" sx={{ color: theme.palette.text.placeholder, marginLeft: 0.5 }} variant="body2">
                {translate(`productDetails.listPrice`)}
                <Typography component="span" sx={{ textDecoration: 'line-through' }}>
                  {fullPrice}
                </Typography>
              </Typography>
            )}

            <PriceActiveLine
              sx={{
                color:
                  fullPrice || price?.priceType === PriceLabelEnum.CAMPAIGN
                    ? theme.palette.text.campaignPrice
                    : theme.palette.text.primary,
              }}
              variant="body1"
            >
              {/* TODO: display total price or single item price? */}
              {price?.formattedValue || totalPrice}
            </PriceActiveLine>
            <SmallestUnitPrice smallestUnitPrice={price?.smallestUnitPrice} />
          </>
        )}
      </>
    </Stack>
  )
}
